var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-row",
    [
      _c(
        "a-col",
        { attrs: { span: 24 } },
        [
          _c(
            "a-card",
            { attrs: { title: _vm.$t("lbl_cash_flow_report_mapping") } },
            [
              _vm._l(_vm.sections, function(section) {
                return _c("CashFlowReportMappingCard", {
                  key: section.title,
                  attrs: {
                    title: section.title,
                    mappings: section.mappings,
                    "account-options": _vm.accountOptions,
                    "newly-added-index":
                      _vm.newlyAddedIndex &&
                      _vm.newlyAddedIndex.section === section.title
                        ? _vm.newlyAddedIndex.index
                        : null
                  },
                  on: {
                    "add-row": _vm.handleAddRow,
                    save: _vm.handleSave,
                    delete: _vm.handleDelete,
                    cancel: _vm.handleCancel
                  }
                })
              }),
              _c("a-divider"),
              _c(
                "a-row",
                { attrs: { type: "flex", justify: "end" } },
                [
                  _c(
                    "a-space",
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "default" },
                          on: { click: _vm.handleDiscard }
                        },
                        [_vm._v(_vm._s(_vm.$t("lbl_discard")))]
                      ),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSaveChanges }
                        },
                        [_vm._v(_vm._s(_vm.$t("lbl_save_changes")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }